/* eslint-disable import/prefer-default-export */
export const GET_WORKSHOP_CALENDAR_VISITS = 'GET_WORKSHOP_CALENDAR_VISITS';
